import React, { useState, useEffect, useContext } from "react";
import { apiGetCommentsByPost, apiPostComment, apiDeleteComment, apiUpdateComment } from '../api/api';
import { Form, Button, Row, Container, Col, Spinner, Modal } from 'react-bootstrap';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import { CommunityContext } from './CommunityContext';
import { ReactComponent as EditIcon } from '../img/edit.svg'
import { ReactComponent as DeleteIcon } from '../img/delete.svg'
import { ReactComponent as CloseIcon } from '../img/close-window.svg'
import './Comments.css'
import { Link } from "react-router-dom";

const Comments = ({postId}) => {
	const { userData } = useContext(CommunityContext)
	const [isDeleted, setIsDeleted] = useState(null);
	const [isUpdated, setIsUpdated] = useState(null);
	const [comments, setComments] = useState([])
	const [InputComment, setInputComment] = useState('')
	const [InputUpdateComment, setInputUpdateComment] = useState('')
	const [showWarning, setshowWarning] = useState(false)
	const [status, setStatus] = useState();
	const [isUpdating, setIsUpdating] = useState(false)
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const createdAtFormat = (createdAt) => {
			return createdAt.substring(11,19) + ", " + createdAt.substring(0, 10)
	}

	const fetchCommentsByPost = async () => {
		try {
			const res = await apiGetCommentsByPost(postId)
			setComments(res.data)
			setIsUpdating(false)
		} catch (error) {
			setComments([])
		}
	}

	const handleCommentChange = (event) => {
		setInputComment(event.target.value)
	}

	const handleSubmit = async (event) => {
		event.preventDefault()
		let data = {
			content: InputComment
		}
		apiPostComment(postId, data).then((res) => {
			fetchCommentsByPost()
			setInputComment('')
		}).catch(error => {
			console.log(error.response)
			alert("Something went wrong! See console log")
		})
}

	const handleDelete = async () => {
		apiDeleteComment(isDeleted.id).then((res) => {
			handleClose()
			fetchCommentsByPost()
			setIsDeleted(null)
			setshowWarning(true)
			setTimeout(() => {
				setshowWarning(false)
			}, 3000)
		}).catch(error => {	
			console.log(error.response)
			alert("Something went wrong! See console log")
		})
	}

	const handleUpdateCommentChange = (event) => {
		setInputUpdateComment(event.target.value)
	}

	const handleUpdate = async (event) => {
		event.preventDefault()
		setIsUpdating(true)
		let data = {
			content: InputUpdateComment
		}
		apiUpdateComment(isUpdated.id, data).then((res) => {
			fetchCommentsByPost()
			setIsUpdating(true)
			setIsUpdated(null)
		}).catch(error => {
			console.log(error.response)
			alert("Something went wrong! See console log")
		})
	}

	useEffect(() => {
		fetchCommentsByPost()
	}, [])

	return (
		<Container className='comment-section'>
			{showWarning &&
				<Alert severity="info" onClose={() => setshowWarning(false)} className='alert' dismissible>
					<AlertTitle>Info</AlertTitle>
					<strong>Comment deleted!</strong>
				</Alert>
			}
			{comments && comments.map((comment, index) => {
				return (
					<Row key={index}>
						<div className='comment-component'>
							<div>
								{userData.email === comment.email || userData.isAdmin ?
									<div>
										<DeleteIcon onClick={() => { 
											setIsDeleted({ id: comment._id }) 
											handleShow()
										}}
											className='delete' 
											title="delete" 
											data-testid="delete-comment" />
										<Modal show={show} onHide={handleClose}>
											<Modal.Header closeButton>
												<Modal.Title>Are you sure you want to delete this comment?</Modal.Title>
											</Modal.Header>
											<Modal.Footer>
												<Button data-testid="cancel-delete-comment" 
																variant="secondary" 
																onClick={() => {
																								setIsDeleted(null)
																								handleClose()
																								}}>
													Cancel
												</Button>
												<Button data-testid="confirm-delete-comment" 
																variant="danger" 
																onClick={() => { handleDelete() }}>
													Delete
												</Button>
											</Modal.Footer>
										</Modal>
									</div>
									:
									null
								}
								{userData.email === comment.email ?
									<div>
										<EditIcon onClick={() => {
											setInputUpdateComment(comment.content)
											setIsUpdated({ id: comment._id })
										}}
											className='edit' title="edit" data-testid="edit-comment" />
									</div> :
									null
								}
							</div>
							<Link className='createdBy' to={`/profile/${comment.email}`}>
								<h5>{comment.username}</h5>
							</Link>
							<h6>Published at {createdAtFormat(comment.createdAt)}</h6>
							<p>{comment.content}</p>
					</div>
					{isUpdated != null && isUpdated.id === comment._id && (
						<div>
							<form onSubmit={handleUpdate}>
								<Row>
									<Col className="col-update-comment">
										<Form.Control data-testid="input-comment-update-bar" value={InputUpdateComment} type="text" name="name" onChange={handleUpdateCommentChange} placeholder="Update Comment..." required></Form.Control>
									</Col>
									<Col className="col-update-comment-button">
										{ isUpdating ? 
										<Button data-testid="submit-update" 
														className="button-submit-update"
														variant="warning" 
														type="submit" 
														disabled> 
														<Spinner as="span" 
																		 animation="border" 
																		 size="sm" 
																		 role="status" 
																		 aria-hidden="true"/>
										</Button> : 
										<Button data-testid="submit-update" 
														className="button-submit-update"
														variant="warning" 
														type="submit">Submit
										</Button>
										}
										<a onClick={() => { setIsUpdated(null) }} target="_blank" rel="noopener noreferrer">
											<CloseIcon className='close' />
										</a>
									</Col>
								</Row>
							</form>
						</div>
						)}
					</Row>
				)
			})}
			<Row>
				<div className='comment-component'>
					<form onSubmit={handleSubmit}>
						<Row>
							<Col className="col-create-comment">
								<Form.Control data-testid="input-comment-bar" value={InputComment} type="text" name="name" onChange={handleCommentChange} placeholder="Comment..." required></Form.Control>
							</Col>
							<Col className="col-create-comment-button">
								<Button variant="warning" type="submit">Submit</Button>
							</Col>
						</Row>
					</form>
				</div>
			</Row>
		</Container>
	)
}

export default Comments;
